import React from 'react';

// Components
import ChangeLogEntries from './ChangeLogEntries';
import LinkToFullChangeLog from './LinkToFullChangeLog';

const ShortChangeLog = ({ entries, username }) => {
  const entriesToShow = entries.slice(0, 3)

  return (
    <div className="admin-profile-card-list-container">
      <h3>Change Log</h3>
      <ChangeLogEntries entries={entriesToShow} />
      {
        (entries.length > 3) && <LinkToFullChangeLog username={username} />
      }
    </div>
  )
}

export default ShortChangeLog



// WEBPACK FOOTER //
// ./src/components/Admin/Profile/ShortChangeLog.js